<template>
  <div class="tabbers col3 bg7">
    <div
      :class="ispc ? 'flex flex-col-top flex-row-between' : ''"
      class="bodyse"
    >
      <div class=" ">
        <div v-if="ispc" class="tabbers_lists flex flex-col-center">
          <div
            @click="pagese(item)"
            class="tabbers_lists_names cur_po"
            v-for="(item, index) in routes"
            :key="index"
          >
            {{ item.meta.name }}
          </div>
        </div>

        <div v-if="ispc" class="tabbers_infos">
          <div class="tabbers_infos flex flex-col-center">
            <a
              class="text-decoration-none"
              href="https://beian.miit.gov.cn/"
              target="_blank"
              >备案号：{{ webinfos.beian }}</a
            >
            <a
              class="text-decoration-none"
              href="http://www.bjkhrs.com/"
              target="_blank"
              >技术支持：科辉荣盛</a
            >
          </div>
          <div class="flex">
            <div class="tabbers_infos"> 提示：</div>
            <div class="tabbers_infos flex-1">
              <div class="flex">
                <div>1、</div>
                <div class="flex-1">本网站若有涉嫌“极限词”请理解为无效词。</div>
              </div>
              <div class="flex">
                <div>2、</div>
                <div class="flex-1">所述案例与产品的数据与功效，来自本公司实施案例和实验数据统计，仅供交流与参考 </div>
              </div>
            </div>
          </div>
        </div>
        <!-- <div class="flex flex-row-between flex-col-top">
          <div class="tabbers_rights">
            <div  class="tabbers_blocs">{{ webinfos.webname }}</div>
            <div class="tabbers_blocs flex flex-col-top">
              <div class="tabbers_blocs_names">地址：</div>
              <div class="flex-1">{{ webinfos.address }}</div>
            </div>
            <div class="tabbers_blocs flex flex-col-top">
              <div class="tabbers_blocs_names">网址：</div>
              <div class="flex-1">{{weburls}}</div>
            </div>
            <div class="tabbers_blocs flex flex-col-top">
              <div class="tabbers_blocs_names">邮箱：</div>
              <div class="flex-1">{{ webinfos.email }}</div>
            </div>
            <div class="tabbers_blocs flex flex-col-top">
              <div class="tabbers_blocs_names">电话：</div>
              <div class="flex-1">{{ webinfos.mobile }}</div>
            </div>
          </div>
          <div>
            <img
              class="tabbers_rights_qrcodes"
              :src="baseUrls + webinfos.qrcode"
              alt=""
            />
          <div style="text-align: center;" class="tabbers_blocs">商务微信</div>
          </div>
        </div> -->
      </div>


      <div v-if="!ispc" class="">
        <div class="tabbers_blocs ">
          <div class="tabbers_infos"> 提示： </div>
          <div class="flex">
            <div class="">1、</div>
            <div class="flex-1">本网站若有涉嫌“极限词”请理解为无效词。</div>
          </div>
          <div class="flex">
            <div class="">2、</div>
            <div class="flex-1">所述案例与产品的数据与功效，来自本公司实施案例和实验数据统计，仅供交流与参考。</div>
          </div>
        </div>
        <div class="flex tabbers_inners flex-row-around flex-col-center">
          <a
            class="text-decoration-none"
            href="https://beian.miit.gov.cn/"
            target="_blank"
            >备案号：{{ webinfos.beian }}</a
          >
          <a
            class="text-decoration-none"
            href="http://www.bjkhrs.com/"
            target="_blank"
            >技术支持：科辉荣盛</a
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import routes from "@/router/routes";
import { onMounted, watch, computed, ref, getCurrentInstance } from "vue";
import { useRouter } from "vue-router";
import { useStore } from "vuex";
const store = useStore();
const router = useRouter();
const { proxy } = getCurrentInstance(); //关键代码
const ispc = computed(() => store.state.ispc);
const baseUrls = computed(() => store.state.baseUrls);
const weburls = computed(() => store.state.weburls);
let webinfos = ref({
  address: "",
  beian: "",
  email: "",
  mobile: "",
  qrcode: "",
  webname: "",
});

const getwebinfo = () => {
  proxy.request("index/webinfo", {}).then((res) => {
    webinfos.value = res.data;
  });
};
getwebinfo();

const pagese = (items) => {
  if (!items.children) {
    pageChange(items.path);
  } else {
    pageChange(items.children[0].path);
  }
};
const pageChange = (urls) => {
  window.scrollTo(0, 0);
  router.push(urls);
};
</script>

<style>
@media screen and (max-width: 768px) {
  .tabbers {
    padding: 30rem 0 0;
  }
  .tabbers_blocs {
    font-size: 24rem;
    line-height: 40rem;
  }
  .tabbers_rights_qrcodes {
    width: 165rem;
  }

  .tabbers_inners {
    border-top: 1px solid #ffffff;
    font-size: 24rem;
    line-height: 40rem;
    text-align: center;
    padding: 35rem 0 35rem;
    margin: 45rem 0 0;
  }
}
@media screen and (min-width: 768px) and (max-width: 1100px) {

  .tabbers {
    padding: 20px 0 30px;
    font-size: 12px;
    line-height: 30px;
  }
  .tabbers_lists {
    border-bottom: 1px solid #ffffff;
    padding-bottom: 8px;
    margin-bottom: 5px;
  }
  .text-decoration-none {
    margin-right: 10px;
  }
  .tabbers_lists_names {
    margin-right: 10px;
  }
  .tabbers_rights {
    margin-right: 15px;
  }
  .tabbers_rights_qrcodes {
    width: 70px;
  }
}
@media screen and (min-width: 1100px) and (max-width: 1400px) {

  .tabbers {
    padding: 20px 0 30px;
    font-size: 14px;
    line-height: 30px;
  }
  .tabbers_lists {
    border-bottom: 1px solid #ffffff;
    padding-bottom: 15px;
    margin-bottom: 15px;
  }
  .text-decoration-none {
    margin-right: 15px;
  }
  .tabbers_lists_names {
    margin-right: 12px;
  }
  .tabbers_rights {
    margin-right: 20px;
  }
  .tabbers_rights_qrcodes {
    width: 85px;
  }
}
@media screen and (min-width: 1400px) and (max-width: 1700px) {

  .tabbers {
    padding: 20px 0 30px;
    font-size: 14px;
    line-height: 30px;
  }
  .tabbers_lists {
    border-bottom: 1px solid #ffffff;
    padding-bottom: 15px;
    margin-bottom: 15px;
  }
  .text-decoration-none {
    margin-right: 20px;
  }
  .tabbers_lists_names {
    margin-right: 20px;
  }
  .tabbers_rights {
    margin-right: 50px;
  }
  .tabbers_rights_qrcodes {
    width: 105px;
  }
}
@media screen and (min-width: 1700px) {

  .tabbers {
    padding: 25px 0 35px;
    font-size: 14px;
    line-height: 30px;
  }
  .tabbers_lists {
    border-bottom: 1px solid #ffffff;
    padding-bottom: 15px;
    margin-bottom: 15px;
  }
  .text-decoration-none {
    margin-right: 20px;
  }
  .tabbers_lists_names {
    margin-right: 20px;
  }
  .tabbers_rights {
    margin-right: 50px;
  }
  .tabbers_rights_qrcodes {
    width: 105px;
  }
}
  .tabbers_margin {
    margin-right: 20px;
  }

.text-decoration-none {
  text-decoration: none;
  color: #fff;
}
.tabbers_lists_names:last-of-type {
  margin-right: 0;
}
</style>
